export default "__VITE_ASSET__da978b36__"